module.exports = __webpack_public_path__ + "img/php.b32fb05e.svg";